// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ChevronDownIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ChevronDownIcon" ref={forwardedRef} {...props}>
      <path d="M3.636 7.636 10 14l6.364-6.364-1.057-1.057-5.307 5.3-5.303-5.304z" />
    </SvgIcon>
  );
});

/**
 * Indicates an expandable/expanded component such as a dropdown or tree navigation
 * @public
 */
export const ChevronDownIcon = /* @__PURE__ */ Object.assign(
  ChevronDownIconComponent,
  { displayName: 'ChevronDownIcon' },
);
